/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchUpdateOrderStatusReqVo
 */
export interface BatchUpdateOrderStatusReqVo {
    /**
     * 订单ID列表
     * @type {Array<number>}
     * @memberof BatchUpdateOrderStatusReqVo
     */
    orderIds: Array<number>;
    /**
     * 目标订单状态码
     * @type {number}
     * @memberof BatchUpdateOrderStatusReqVo
     */
    orderStatus: number;
}

/**
 * Check if a given object implements the BatchUpdateOrderStatusReqVo interface.
 */
export function instanceOfBatchUpdateOrderStatusReqVo(value: object): value is BatchUpdateOrderStatusReqVo {
    if (!('orderIds' in value) || value['orderIds'] === undefined) return false;
    if (!('orderStatus' in value) || value['orderStatus'] === undefined) return false;
    return true;
}

export function BatchUpdateOrderStatusReqVoFromJSON(json: any): BatchUpdateOrderStatusReqVo {
    return BatchUpdateOrderStatusReqVoFromJSONTyped(json, false);
}

export function BatchUpdateOrderStatusReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchUpdateOrderStatusReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderIds': json['orderIds'],
        'orderStatus': json['orderStatus'],
    };
}

export function BatchUpdateOrderStatusReqVoToJSON(json: any): BatchUpdateOrderStatusReqVo {
    return BatchUpdateOrderStatusReqVoToJSONTyped(json, false);
}

export function BatchUpdateOrderStatusReqVoToJSONTyped(value?: BatchUpdateOrderStatusReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderIds': value['orderIds'],
        'orderStatus': value['orderStatus'],
    };
}

